// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"796ba352feca0c9db82c","883":"2b8a0e03e52b66dbdbce"}[chunkId] + ".js";
};